import request from '@/utils/request'

// 标签组列表
export const tagGroupsList = (pageData, formData) => {
    return request.post(`/tagGroup/page/${pageData.page}/${pageData.pageSize}`, formData)
}

// 新增标签组
export const addTagGroups = (formData) => {
    return request.post(`/tagGroup`, formData)
}

// 修改标签组-状态
export const editTagGroupState = (formData) => {
    return request.put(`/tagGroup/state`, formData)
}

// 修改标签组
export const editTagGroup = (formData) => {
    return request.put(`/tagGroup`, formData)
}

// 根据应用场景-获取标签组
export const tagGroupsListByUsageScenario = (formData) => {
    return request.get(`/tagGroup/scenario`, {params: formData})
}
